import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e1a564e2")

_pushScopeId("data-v-e1a564e2")
const _hoisted_1 = { class: "flex flex-row rounded-3xl bg-gray-lp-200 px-2 items-center justify-center gap-2 py-1" }
const _hoisted_2 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "py-3"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_8 = { class: "flex my-1" }
const _hoisted_9 = {
  key: 0,
  class: "ml-1 relative"
}
const _hoisted_10 = { class: "text-12px max-w-xs" }
const _hoisted_11 = { class: "flex my-1" }
const _hoisted_12 = {
  key: 0,
  class: "ml-1 relative"
}
const _hoisted_13 = { class: "inline-flex" }
const _hoisted_14 = { class: "rounded bg-gray-lp-200 text-black-lp-300 p-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailDeliverySection = _resolveComponent("DetailDeliverySection")!
  const _component_DetailItemSection = _resolveComponent("DetailItemSection")!
  const _component_DetailFtzSection = _resolveComponent("DetailFtzSection")!
  const _component_AdditionalInformationSection = _resolveComponent("AdditionalInformationSection")!
  const _component_DetailPaymentSection = _resolveComponent("DetailPaymentSection")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CreateUpdate = _resolveComponent("CreateUpdate")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_DetailRejectPopup = _resolveComponent("DetailRejectPopup")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: false,
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.getTitle,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail
    }, {
      "top-right": _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("bookingShipment.detail.viewData")), 1),
          _createVNode("div", {
            id: "toggle_hide_info_detail",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCheckEligibleShowDetail && _ctx.onCheckEligibleShowDetail(...args))),
            class: 
            `toggle-switch inline-block cursor-pointer ${
              _ctx.isShowInfoDetail
                ? `toggle-active ${'bg-red-lp-100'}`
                : `${'bg-gray-lp-200'}`
            }`
          
          }, [
            _hoisted_3
          ], 2)
        ])
      ]),
      data: _withId(() => [
        _createVNode(_component_DetailDeliverySection, {
          detailData: _ctx.detailData,
          isShowInfoDetail: _ctx.isShowInfoDetail
        }, null, 8, ["detailData", "isShowInfoDetail"]),
        _hoisted_4,
        _createVNode(_component_DetailItemSection, {
          detailData: _ctx.detailData,
          formAccountCurrencyPrefix: _ctx.formAccountCurrencyPrefix
        }, null, 8, ["detailData", "formAccountCurrencyPrefix"]),
        (_ctx.isFtzAccount)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_ctx.isFtzAccount)
          ? (_openBlock(), _createBlock(_component_DetailFtzSection, {
              key: 1,
              detailData: _ctx.detailData,
              photos: _ctx.ftzAttachmentMixFiles,
              sttCipl: _ctx.detailData.sttFtzCipl,
              isShowInfoDetail: _ctx.isShowInfoDetail
            }, null, 8, ["detailData", "photos", "sttCipl", "isShowInfoDetail"]))
          : _createCommentVNode("", true),
        (_ctx.isInternationalShipment && _ctx.eligibleAdditionalInfo)
          ? (_openBlock(), _createBlock(_component_AdditionalInformationSection, {
              key: 2,
              email: _ctx.detailData.sttRecipientEmail,
              identityNumber: _ctx.detailData.sttIdentityNumber,
              interTaXNumber: _ctx.detailData.sttInterTaxNumber,
              dutyTaxTerms: _ctx.detailData.sttDutyTaxTerms,
              commodity: _ctx.commodityDetailValue,
              photos: _ctx.attachMixFiles,
              sttCipl: _ctx.detailData.sttCipl,
              productTypeName: _ctx.productTypeName,
              bookedByCountry: _ctx.detailData.sttBookedByCountry,
              isShowInfoDetail: _ctx.isShowInfoDetail,
              isShipmentCaOldForm: _ctx.isShipmentCaOldForm,
              sttBookedByCountryMy: _ctx.sttBookedByCountryMy,
              isInternational: _ctx.detailData.isInternational,
              detailData: _ctx.detailData
            }, null, 8, ["email", "identityNumber", "interTaXNumber", "dutyTaxTerms", "commodity", "photos", "sttCipl", "productTypeName", "bookedByCountry", "isShowInfoDetail", "isShipmentCaOldForm", "sttBookedByCountryMy", "isInternational", "detailData"]))
          : _createCommentVNode("", true),
        _hoisted_7,
        (_ctx.detailData.tariffVisible)
          ? (_openBlock(), _createBlock(_component_DetailPaymentSection, {
              key: 3,
              detailData: _ctx.detailData,
              formAccountCurrencyPrefix: _ctx.formAccountCurrencyPrefix
            }, null, 8, ["detailData", "formAccountCurrencyPrefix"]))
          : _createCommentVNode("", true)
      ]),
      "sub-data": _withId(() => [
        _createVNode(_component_DataWrapper, {
          label: _ctx.statusChipsStyle.title
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_Chips, {
                rounded: "",
                class: "font-medium",
                label: _ctx.statusChipsStyle.label,
                color: _ctx.statusChipsStyle.color,
                textColor: _ctx.statusChipsStyle.textColor
              }, null, 8, ["label", "color", "textColor"]),
              (_ctx.statusChipsStyle.toolTip)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("img", {
                      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleStatusPanel($event, 'tooltipStatus'))),
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleStatusPanel($event, 'tooltipStatus'))),
                      src: 
                _ctx.toolTip1
                  ? require('@/app/ui/assets/svg/info-red.svg')
                  : require('@/app/ui/assets/svg/info.svg')
              ,
                      alt: ""
                    }, null, 40, ["src"]),
                    _createVNode(_component_OverlayPanel, {
                      ref: "tooltipStatus",
                      appendTo: "body"
                    }, {
                      default: _withId(() => [
                        _withDirectives(_createVNode("div", _hoisted_10, null, 512), [
                          [_directive_sanitize_html, _ctx.detailData.sttLastStatusDescription]
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.detailData.sttLastStatus?.toLowerCase() !== 'cnx')
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: _ctx.statusTroubleChipsStyle.title
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_Chips, {
                    rounded: "",
                    class: "font-medium",
                    label: _ctx.statusTroubleChipsStyle.label,
                    color: _ctx.statusTroubleChipsStyle.color,
                    textColor: _ctx.statusTroubleChipsStyle.textColor
                  }, null, 8, ["label", "color", "textColor"]),
                  (_ctx.statusTroubleChipsStyle.toolTip)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("img", {
                          onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleStatusPanel($event, 'tooltipStatusTrouble'))),
                          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleStatusPanel($event, 'tooltipStatusTrouble'))),
                          src: 
                  _ctx.toolTip2
                    ? require('@/app/ui/assets/svg/info-red.svg')
                    : require('@/app/ui/assets/svg/info.svg')
                ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _createVNode(_component_OverlayPanel, {
                          ref: "tooltipStatusTrouble",
                          appendTo: "body"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.detailData.sttWarningStatusDescription), 1)
                          ]),
                          _: 1
                        }, 512)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.sttLastStatus?.toLowerCase() === 'cnx')
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.detail.rejectedDate'),
                value: _ctx.formatDate(_ctx.detailData.sttUpdatedAt),
                caption: _ctx.detailData.sttUpdatedBy
              }, null, 8, ["label", "value", "caption"]),
              _createVNode("div", _hoisted_13, [
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.detailData.sttReasonMapping?.reasonDescription), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_CreateUpdate, {
          createdAt: _ctx.detailData.sttCreatedAt,
          createdBy: _ctx.detailData.sttCreatedBy,
          updatedAt: _ctx.detailData.sttUpdatedAt,
          updatedBy: _ctx.detailData.sttUpdatedBy
        }, null, 8, ["createdAt", "createdBy", "updatedAt", "updatedBy"]),
        (_ctx.isEditAble && !_ctx.isSenderAcount && _ctx.isTempCondition && _ctx.$route?.meta?.customPath !== 'lacak-pengiriman')
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 2,
              customClass: "px-1 sm:px-12 py-2.5 text-red-lp-100",
              outline: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToEdit(_ctx.$route.query.id, _ctx.$route.params.id))),
              title: _ctx.$t('bookingShipment.action.editBooking')
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.sttIsAllowCancel && !_ctx.isSenderAcount)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 3,
              customClass: "px-1 sm:px-8 py-2.5",
              textColor: "white",
              title: _ctx.$t('bookingShipment.action.cancelBooking'),
              onClick: _ctx.showCancelConfirmation
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        _hoisted_15,
        (!_ctx.isSenderAcount)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 4,
              label: _ctx.$t('bookingShipment.detail.printReceipt')
            }, {
              default: _withId(() => [
                _createVNode(_component_LpButton, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.print('thermal'))),
                  class: "mt-3 w-48",
                  flat: "",
                  dense: "",
                  iconLeft: "printer",
                  title: _ctx.$t('bookingShipment.detail.printThermalReceipt')
                }, null, 8, ["title"]),
                _createVNode(_component_LpButton, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.print('thermal-pdf'))),
                  class: "w-48",
                  flat: "",
                  dense: "",
                  iconLeft: "printer",
                  title: _ctx.$t('bookingShipment.detail.printThermalReceiptPDF')
                }, null, 8, ["title"]),
                _createVNode(_component_LpButton, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.print('basic'))),
                  class: "w-48",
                  flat: "",
                  iconLeft: "invoice",
                  dense: "",
                  title: _ctx.$t('bookingShipment.detail.PrintBasic')
                }, null, 8, ["title"]),
                (_ctx.canPrintCommercialInvoiceA4)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.print('commercial-invoice-a4'))),
                      class: "w-48",
                      flat: "",
                      iconLeft: "document-download-outline-grey",
                      dense: "",
                      title: 'Commercial Invoice A4',
                      "data-testid": "stt-detail-ci-print-a4"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.canPrintCommercialInvoiceA6)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 1,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.print('commercial-invoice-a6'))),
                      class: "w-48",
                      flat: "",
                      iconLeft: "document-download-outline-grey",
                      dense: "",
                      title: 'Commercial Invoice A6',
                      "data-testid": "stt-detail-ci-print-a6"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _createVNode(_component_DetailRejectPopup, {
      "custom-path": _ctx.customPath,
      isShow: _ctx.isRejectPopup,
      "onUpdate:isShow": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isRejectPopup = $event)),
      sttNumber: _ctx.detailData.sttNo,
      isDetail: "",
      onSuccess: _ctx.getDetail
    }, null, 8, ["custom-path", "isShow", "sttNumber", "onSuccess"])
  ], 64))
})